var map = {
	"./1.jpg": 7599,
	"./10.jpg": 7423,
	"./11.jpg": 1042,
	"./2.jpg": 3248,
	"./3.webp": 6270,
	"./4.png": 3282,
	"./5.jpg": 5875,
	"./6.webp": 4221,
	"./8.jpg": 3034,
	"./9.jpg": 5223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5806;